import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import data from './herram_automotor.json'

export class herram_automotor extends React.Component {

	

	


	render(){

		return (
				<div id="inicio">
					
					<section class="container-fluid section-nuestros-productos">
					<article class="row">
								<div class="col-md-12 card-col-flex">


							<table class="table card-lb">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Accesorios</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="row">1</th>
										<td>LLAVE ALLEN TIPO BONDHUS</td>
									</tr>
									<tr>
										<th scope="row">2</th>
										<td>LLAVE COMB/FIJA/ESTRIADA</td>
									</tr>
									<tr>
										<th scope="row">3</th>
										<td>LLAVE FRANCESA</td>
									</tr>
									<tr>
										<th scope="row">4</th>
										<td>LLAVE PARA TAPA CILINDROS</td>
									</tr>
									<tr>
										<th scope="row">5</th>
										<td>INSERTO</td>
									</tr>
									<tr>
										<th scope="row">6</th>
										<td>MACHO PARA INSERTO</td>
									</tr>
									<tr>
										<th scope="row">7</th>
										<td>PORTA INSERTO</td>
									</tr>
									<tr>
										<th scope="row">8</th>
										<td>MANGO DE FUERZA</td>
									</tr>
									<tr>
										<th scope="row">9</th>
										<td>TUBO RIBE</td>
									</tr>
									<tr>
										<th scope="row">10</th>
										<td>PUNTA PHILLIPS</td>
									</tr>
									<tr>
										<th scope="row">11</th>
										<td>PUNTA PLANA</td>
									</tr>
									<tr>
										<th scope="row">12</th>
										<td>PUNTA RIBE</td>
									</tr>
									<tr>
										<th scope="row">13</th>
										<td>PUNTA TORX</td>
									</tr>
									<tr>
										<th scope="row">14</th>
										<td>TORQUIMETRO</td>
									</tr>
									<tr>
										<th scope="row">15</th>
										<td>TUBO ALLEN CORTO/LARGO</td>
									</tr>
									<tr>
										<th scope="row">16</th>
										<td>TUBO HEXAGONAL/ESTRIADO</td>
									</tr>
									<tr>
										<th scope="row">17</th>
										<td>TUBO PUNTA MULTIESTRIA CORTO/LARGO</td>
									</tr>

									<tr>
										<th scope="row">18</th>
										<td>TUBO TORX MACHO/HEMBRA -  CORTO/LARGO</td>
									</tr>
									<tr>
										<th scope="row">19</th>
										<td>TUBO PARA POLEA DE ALTERNADOR</td>
									</tr>
									<tr>
										<th scope="row">20</th>
										<td>TUBO SACABUJIAS</td>
									</tr>
									<tr>
										<th scope="row">21</th>
										<td>TUBO PARA TAPA DE CILINDROS</td>
									</tr>
									<tr>
										<th scope="row">22</th>
										<td>TUBO PARA SONDA LANDA</td>
									</tr>
									<tr>
										<th scope="row">23</th>
										<td>TUBO DE INYECTORES</td>
									</tr>
									<tr>
										<th scope="row">24</th>
										<td>LEVANTAVALVULAS</td>
									</tr>

									<tr>
										<th scope="row">25</th>
										<td>EXTRACTOR DE 3 GARRAS</td>
									</tr>
									<tr>
										<th scope="row">26</th>
										<td>SACA PRECAP</td>
									</tr>
									<tr>
										<th scope="row">27</th>
										<td>DESTORNILLADOR DE ALTO IMPACTO</td>
									</tr>
									<tr>
										<th scope="row">28</th>
										<td>PRENSA-AROS</td>
									</tr>
									<tr>
										<th scope="row">29</th>
										<td>EXTRACTOR DE ROTULA</td>
									</tr>

									<tr>
										<th scope="row">30</th>
										<td>MEDIDOR DE VOLTAJE</td>
									</tr>
									<tr>
										<th scope="row">31</th>
										<td>PROBADOR DE BUJIA</td>
									</tr>
									<tr>
										<th scope="row">32</th>
										<td>PINZA DE ABRAZADERA PARA MANGUERA DE AGUA</td>
									</tr>
									<tr>
										<th scope="row">33</th>
										<td>PINZA PARA FLEJE DE SEMIEJE</td>
									</tr>
									<tr>
										<th scope="row">34</th>
										<td>ESPEJITO DE INSPECCION</td>
									</tr>
									<tr>
										<th scope="row">35</th>
										<td>PESCATUERCA</td>
									</tr>
									<tr>
										<th scope="row">36</th>
										<td>SACA FILTRO</td>
									</tr>
									<tr>
										<th scope="row">37</th>
										<td>SONDA (PULGADAS Y MM)</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>		
									<td colspan="2" className="text-center"><button className="topScroll linkTable">subir</button></td>
									</tr>
								</tfoot>
							</table>

						</div>
									   
						
					</article>
				</section>		


				</div>

				


				);
	}
} 


// WEBPACK FOOTER //
// ./src/components/herram_automotor.js